/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { BackgroundPanel, Button, ImageButton } from 'vr-react-components';
import { setNotification } from '../store/slice/privateSlice';

const Notification = () => {
    const dispatch = useDispatch()

    const notification = useSelector((state) => state.private.notification)
    const device = useSelector((state) => state.private.device)

    const [visible, setVisible] = useState(true)
    const [text, setText] = useState("")

    let timeout;
    useEffect(() => {
        if (notification)
            setVisible(true)

        if (!(notification instanceof Object))
            setText(notification)
        else
            setText(notification.text)

    }, [notification, dispatch]);

    useEffect(() => {

        return () => {
            clearTimeout(timeout);
        };
    }, [timeout])

    if (visible && !timeout) {
        timeout = setTimeout(() => {
            setVisible(false)
            dispatch(setNotification(null))
            setText("")
        }, 5000);
    }

    return (
        <a-entity position={device.inVRMode ? `0 1.6 -2`: `0 1.6 -0.85`}>
            {visible &&
                <BackgroundPanel
                    width={2}
                    height={notification instanceof Object ? 0.4 : 0.15}
                    opacity={1}
                    color={"#191919"}
                >
                    <ImageButton
                        width={0.08}
                        height={0.08}
                        position={notification instanceof Object ? "0.93 0.13 0" : "0.9 0 0"}
                        src="#CloseWhite"
                        aframeClasses="collidable"
                        onClickHandler={() => {
                            dispatch(setNotification(false))
                            clearTimeout(timeout)
                        }}
                    />
                    <a-text
                        position={notification instanceof Object ? "0 0.07 0.1" : "0 0 0.1"}
                        width={1.35}
                        height={1.35}
                        sizeDecimal={text?.length * 0.7}
                        value={text}
                        align="center"
                    />
                    {
                        notification.buttons?.map((role, i) => {
                            return <Button
                                key={i}
                                text={role}
                                type={Button.constants[notification.buttonTypes[i]]}
                                onClickHandler={() => {
                                    notification.buttonFunctions(role, notification.data);
                                    setVisible(false);
                                    clearTimeout(timeout);
                                }}
                                aframeClasses={"collidable"}
                                width={0.4}
                                height={0.1}
                                position={`${-0.25 * (notification.buttons.length) + (i * 0.45) + 0.301} -0.08 0.01`}
                                textWidth={15}
                                textSizeDecimal={42}
                            />
                        })
                    }
                </BackgroundPanel>
            }
        </a-entity>
    )
}

export default Notification
